import type { SYSTableDefIds } from "../../../../../_ovlclient/src"
import { html, SYSBaseElement } from "../../../../../_ovlclient/src"
import { Data } from "../../../../../_ovlclient/src/dataapi"
import type { DialogHolderParams } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  DialogClose,
  DialogOkCancel,
} from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  ProcessEnd,
  ProcessStart,
} from "../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { NavDef } from "../../../../../_ovlclient/src/library/table/navcontrol"
import { TableGet } from "../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import { UserAdministration_UserType } from "../user/tabledef"

export class DialogSYSUserAdministrationUserRoleTransfer extends SYSBaseElement {
  async init() {
    this.dialog = "SYSUserAdministration_UserRoleTransfer"
    await super.init()
  }
  async handleSave() {
    let sync = false

    let selectedUserTable = TableGet<UserAdministration_UserType>(
      "SYSUserAdministration_User",
      { byKeys: "SelectedTimeDesc" }
    )
    let fromUserId =
      selectedUserTable.rows[selectedUserTable.getKeys()[0]].CntctCode
    let fromUserName = `${
      selectedUserTable.rows[selectedUserTable.getKeys()[0]].FirstName
    } ${selectedUserTable.rows[selectedUserTable.getKeys()[0]].LastName}`

    let selectedTargetUserTable = TableGet<UserAdministration_UserType>(
      "SYSUserAdministration_UserRoleTransfer",
      { byKeys: "Selected" }
    )
    let toUserIds = selectedTargetUserTable
      .getKeys()
      .map((k) => selectedTargetUserTable.rows[k].CntctCode)
    if (
      (await DialogOkCancel(
        T("SYSUserAdministrationUserRoleTransferDoConfirm", [
          fromUserName,
          toUserIds.length,
        ])
      )) === 2
    ) {
      return
    }

    if (
      (await DialogOkCancel(
        T("SYSUserAdministrationUserRoleTransferSyncConfirm", [
          fromUserName,
          toUserIds.length,
        ]),
        {
          buttonText_01: "SYSYes",
          buttonText_02: "SYSNo",
        }
      )) === 1
    ) {
      sync = true
    }
    try {
      ProcessStart("SYSUserAdministrationUserRoleDoTransfer", {
        lock: { dialog: "SYSUserAdministration_UserRoleTransfer" },
      })

      let res = await Data("useradministration/transferroles", {
        fromUserId,
        toUserIds,
        sync,
      })
      DialogClose("SYSUserAdministration_UserRoleTransfer")
    } finally {
      ProcessEnd("SYSUserAdministrationUserRoleDoTransfer")
    }
  }
  async getUI() {
    let dialogHolderParams: DialogHolderParams

    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSUserAdministration_UserRoleTransfer",
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () => {
          let selectedUserTable = TableGet<UserAdministration_UserType>(
            "SYSUserAdministration_User",
            { byKeys: "SelectedTimeDesc" }
          )
          let fromUserName = `${
            selectedUserTable.rows[selectedUserTable.getKeys()[0]].FirstName
          } ${selectedUserTable.rows[selectedUserTable.getKeys()[0]].LastName}`
          return T("SYSUserAdministrationUserRoleTransferTitle", [fromUserName])
        },
        body: () =>
          html`<ovl-table
            class="fd-table fd-table--no-horizontal-borders"
            .props=${() =>
              <SYSTableDefIds>"SYSUserAdministration_UserRoleTransfer"}
          >
          </ovl-table>`,
        footer: async () => {
          return html` <button
              @click=${async (e) => {
                await this.handleSave()
              }}
              class="fd-button fd-button--positive"
              ?disabled=${TableGet("SYSUserAdministration_UserRoleTransfer", {
                byKeys: "Selected",
              }).getKeys().length === 0}
            >
              <i class="sap-icon--accept"></i>
            </button>`
        },
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
